import React, {Component} from 'react';
import './merchandiseMix.less';

//商品类型模版
class MerchandiseMix extends Component {
  constructor(props) {
    super(props);
    this.state = {
      goodsList: [],
    };
  }

  componentWillMount() {
    this.setState({goodsList: this.props.goodsList});
  }

  componentWillReceiveProps(props) {
    this.setState({goodsList: props.goodsList});
  }

  // 跳转到详情页
  toDetail = (id) => {
    this.props.toDetail(id);
  }

  render() {
    const {goodsList} = this.state;
    return (
      <ul id="merchandiseMix">
        <li className="title">
          <p style={{width: '402px'}}>商品</p>
          <p style={{width: '250px'}}>商品单价</p>
          <p>数量</p>
        </li>
        {
          goodsList.map((item, index) => (
            <li key={index} onClick={this.toDetail.bind(this, item.goods_id)}>
              <div>
                <img src={item.goods_picture} />
                <p>{item.goods_name}</p>
              </div>
              <p style={{width: '250px'}}>￥{item.sale_price}</p>
              <p>{item.goods_amount}</p>
            </li>
          ))
        }
      </ul>
    );
  }
}
export default MerchandiseMix;



// WEBPACK FOOTER //
// ./src/components/frontEnd/merchandiseMix/merchandiseMix.jsx